gsap.registerPlugin(ScrollTrigger);


// ---------------------------------------------------------------------------
// HEADER: Add-remove class on scroll
// ---------------------------------------------------------------------------



const setMargin = () =>{
  let headerHeight = $('.header').height() + 'px';
  $('main').css('margin-top', headerHeight);
}

const addScrolled = () =>{
  if (window.matchMedia('(min-width: 768px)').matches){
    document.getElementsByClassName('header')[0].classList.add('scrolled');
  }
  
}
const removeScrolled = () =>{
  if (window.matchMedia('(min-width: 768px)').matches){
    document.getElementsByClassName('header')[0].classList.remove('scrolled');
  }
}


$(document).ready(function(){
  setMargin();
  ScrollTrigger.create({
    start: 80,
    end: () => $(document).height(),
    onEnter: () => addScrolled(),
    onLeaveBack: () => removeScrolled()
  });
})


// ---------------------------------------------------------------------------
// GSAP ANIMATIONS
// ---------------------------------------------------------------------------

function stdAnimation(element, duration, y){
  element.forEach((el)=> {
    gsap.from(el, {
      duration: [duration], 
      opacity: 0, 
      y: [y],
      scrollTrigger: {
        trigger: el
      }
    });
  })
}


const initTransitions = () => {
  if(document.getElementsByClassName('content')[0]){
    stdAnimation(document.querySelectorAll('.content svg'), 1, 50);
    stdAnimation(document.querySelectorAll('.content .title'), 1, 50);
    stdAnimation(document.querySelectorAll('.content .subtitle'), 1, 50);
    stdAnimation(document.querySelectorAll('.content .desc'), 1, 50);
  }


  if(document.getElementsByClassName('paragraph')[0]){
    stdAnimation(document.querySelectorAll('.paragraph p'), 1, 50);
  }


  if(document.getElementsByClassName('paragraph-quote')[0]){
    stdAnimation(document.querySelectorAll('.paragraph-quote p'), 1, 50);
  }
  
  if(document.getElementsByClassName('menu-list')[0]){
    stdAnimation(document.querySelectorAll('.menu-list .price'), 1, 50);
    stdAnimation(document.querySelectorAll('.menu-list h2'), 1, 50);
    stdAnimation(document.querySelectorAll('.menu-list .subtitle'), 1, 50);
    stdAnimation(document.querySelectorAll('.menu-list .desc'), 1, 50);
    stdAnimation(document.querySelectorAll('.menu-list .menu-download'), 1, 50);
  }

  if(document.getElementsByClassName('contact-form')[0]){
    stdAnimation(document.querySelectorAll('.contact-form form'), 1, 50);
  }

  if(document.getElementsByClassName('maps-contatti')[0]){
    stdAnimation(document.querySelectorAll('.maps-contatti .subtitle'), 1, 50);
    stdAnimation(document.querySelectorAll('.maps-contatti p'), 1, 50);
    stdAnimation(document.querySelectorAll('.maps-contatti #map'), 1, 50);
  }

  if(document.getElementsByClassName('promo-preview')[0]){
    stdAnimation(document.querySelectorAll('.promo-preview_block'), 1, 50);
  }
}
initTransitions();




const parralax = () =>{
  if (window.matchMedia('(max-width: 990px)').matches) {
    if (rellax) rellax.destroy();
  } else {
    var rellax = new Rellax('.parrallax', {
      center: true
    });
  }
}
if(!document.querySelectorAll('.header.half')[0]){
  parralax();
}

window.onresize = parralax;